<app-dialog
  #dialog
  [key]="'modal-transfer-company'"
  [action]="'transfer-company'"
  [headerTheme]="'simple'"
  [title]="'Transferir Empresa'"
  [maxWidth]="'600px'">
  <div class="transfer-company-modal" *ngIf="company">
    <!-- Informações da Empresa -->
    <div class="company-info-section">
      <h3 class="section-title">Empresa</h3>
      <div class="info-card">
        <div class="info-row">
          <span class="info-label">Nome:</span>
          <span class="info-value">{{ company.displayName || company.corporateName }}</span>
        </div>
        <div class="info-row" *ngIf="company.cnpj">
          <span class="info-label">CNPJ:</span>
          <span class="info-value">{{ company.cnpj }}</span>
        </div>
        <div class="info-row" *ngIf="currentTenantName">
          <span class="info-label">Tenant Atual:</span>
          <span class="info-value">{{ currentTenantName }}</span>
        </div>
      </div>
    </div>

    <!-- Mensagem Informativa -->
    <div class="warning-message">
      <i class="pi pi-exclamation-triangle"></i>
      <p>Esta ação é irreversível. A empresa será transferida para o tenant selecionado.</p>
    </div>

    <!-- Formulário de Seleção -->
    <form [formGroup]="transferForm" appAutoFormGroup class="transfer-form">
      <div class="form-field">
        <app-select
          [formGroup]="transferForm"
          [controlName]="'targetTenantId'"
          [label]="'Tenant de Destino'"
          [placeholder]="'Selecione o tenant de destino'"
          [options]="(tenants$ | async) || []">
        </app-select>
      </div>
    </form>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [label]="'Cancelar'"
        [type]="'button'"
        theme="white"
        (sendButtonClick)="closeModal()">
      </app-button>
      <app-button
        [label]="isLoading ? 'Transferindo...' : 'Confirmar Transferência'"
        [type]="'button'"
        [disabled]="!isFormValid() || isLoading"
        [isLoading]="isLoading"
        icon="pi pi-share-alt"
        (sendButtonClick)="submitAction()">
      </app-button>
    </div>
  </ng-template>
</app-dialog>
